

































import { AppToggle } from '@/uikit';
import { Button } from '@/pages/profile/components';
import AppHeading from '@/uikit/typography/Heading/AppHeading.vue';
import { Message } from '../settings/components';
import {
  FORM_ERROR_MESSAGE,
  FORM_SUCCESS_MESSAGE,
  INFO_TEXT,
} from '@/pages/profile/views/settings/consts';
export default {
  name: 'AccessPermission',
  components: {
    AppHeading,
    AppToggle,
    Button,
    Message,
  },
  data() {
    return {
      accessPermission: {
        /// is_basic_access: false,
        is_address_access: false,
        is_study_access: false,
        is_work_access: false,
        is_directions_access: false,
        is_results_access: false,
        is_employment_access: false,
        is_achievements_access: false,
      },
      isSelectAllState: false,
      savedData: false,
      isError: false,
      savingData: false,
    };
  },
  computed: {
    isLoaded(): boolean {
      return this.$store.state.user.profileLoaded;
    },
    getStoreAccessPerms() {
      return this.$store.state.user.profile.access_permissions;
    },
    saveDisabled(): boolean {
      if (!this.isLoaded) {
        return true;
      } else {
        return Object.keys(this.accessPermission).every(
          (key: string) =>
            this.accessPermission[key] === this.getStoreAccessPerms[key]
        );
      }
    },
    getMessage(): string {
      if (this.isError) {
        return FORM_ERROR_MESSAGE;
      } else if (this.savedData) {
        return FORM_SUCCESS_MESSAGE;
      }
      return INFO_TEXT;
    },
  },
  watch: {
    isLoaded(newVal: boolean) {
      if (newVal) {
        this.accessPermission = { ...this.getStoreAccessPerms };
        this.syncPermissionToSelectAll();
      }
    },
  },
  created() {
    if (this.isLoaded) {
      this.accessPermission = { ...this.getStoreAccessPerms };
      this.syncPermissionToSelectAll();
    }
  },
  methods: {
    toggleInput() {
      this.savedData = false;
      this.isError = false;
      this.syncPermissionToSelectAll();
    },
    syncPermissionToSelectAll() {
      const permissionsValues = Object.values(this.accessPermission);
      if (permissionsValues.every((p) => p)) {
        this.isSelectAllState = true;
      }
      if (permissionsValues.every((p) => !p)) {
        this.isSelectAllState = false;
      }
    },
    setSelectedAll() {
      for (let key in this.accessPermission) {
        this.accessPermission[key] = this.isSelectAllState;
      }
    },
    async savePermissions() {
      try {
        this.savingData = true;
        await this.$store.dispatch('user/updateProfile', {
          access_permissions: this.accessPermission,
        });
        this.isError = false;
      } catch (e) {
        this.isError = true;
        // console.log(e);
      } finally {
        this.savedData = true;
        this.savingData = false;
      }
    },
    reset() {
      this.accessPermission = { ...this.getStoreAccessPerms };
      this.isSelectAllState = false;
    },
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/accessPermission/AccessPermission.vue